import {
    Component,
    ChangeDetectionStrategy,
    ViewChild,
    ElementRef,
    ChangeDetectorRef,
    NgZone,
    OnDestroy,
    AfterViewInit,
} from '@angular/core';
import { Portal } from '@angular/cdk/portal';
import { Overlay, MapBrowserEvent } from 'ol';
import { IsavMap } from '../../map';
import OverlayPositioning from 'ol/Overlay';

@Component({
    selector: 'isav-context-menu-handler',
    templateUrl: './context-menu-handler.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IsavContextMenuHandler implements AfterViewInit, OnDestroy {
    @ViewChild('contextMenu', { static: true }) contextMenuEl: ElementRef<HTMLDivElement>;

    contextMenuFeature: Portal<any>;

    private _contextMenu: Overlay;

    options: Portal<any>[] = [];

    constructor(
        private isavMap: IsavMap,
        private cdRef: ChangeDetectorRef,
        private ngZone: NgZone
    ) {}

    ngAfterViewInit(): void {
        this._contextMenu = new Overlay({
            element: this.contextMenuEl.nativeElement,
            positioning: 'top-left',
            stopEvent: false,
            offset: [0, 0],
        });

        this.isavMap.map.addOverlay(this._contextMenu);
        this.isavMap.map.addEventListener('click', this.handleClick);
        this.isavMap.map.addEventListener('contextmenu', this.handleContextMenu);
    }

    ngOnDestroy(): void {
        this.isavMap.map.removeOverlay(this._contextMenu);
        this.isavMap.map.removeEventListener('contextmenu', this.handleContextMenu);
    }

    handleContextMenu = (event: MapBrowserEvent<UIEvent>) => {
        event.preventDefault();

        const coordinates = this.isavMap.map.getCoordinateFromPixel(event.pixel);
        this.isavMap.latestContextMenuCoordinates = this.isavMap.fromMapCoordinate(coordinates);

        this.options = this.isavMap.contextMenuOptions.map((o) => {
            return o.getPortal();
        });

        this.ngZone.runGuarded(() => {
            setTimeout(() => {
                if (this.options.length) {
                    this._contextMenu.setPosition(coordinates);
                } else {
                    this._contextMenu.setPosition(undefined);
                }
                this.cdRef.markForCheck();
            });
        });
    };

    handleClick = () => {
        this._contextMenu.setPosition(undefined);
    };
}
